<div class="h-[90vh] w-[600px] relative flex justify-center items-center">
  <iframe
    [src]="_url"
    class="w-full h-full object-cover"
    [title]="data.title || 'Document'"
  >
  </iframe>
</div>
